import { CommonModule } from '@angular/common';
import { Component, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { OrderChooserComponent } from '@app/customizer-shared/components/order-chooser/order-chooser.component';
import { BaseModal } from '@modals/base-modal';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';

@Component({
    selector: 'app-order-chooser-modal',
    templateUrl: './order-chooser-modal.component.html',
    styleUrls: ['./order-chooser-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [OrderChooserComponent, CommonModule]
})
export class OrderChooserModalComponent extends BaseModal {

	orderSelect: EventEmitter<number | null> = new EventEmitter();

	constructor(
		breadcrumbService: BreadcrumbService,
		public orderOnBehalfService: OrderOnBehalfService
	) {
		super(breadcrumbService);
	}

	onSelect(orderId: number | null) {
		this.orderSelect.emit(orderId);
		this.closeAndDestroy();
	}

}
